export default {
    businessList: [],
    selectedBusiness: '',
    activeBusinessBranding: ''
}
